import React from 'react'
import styles from './PillToggle.module.css'

export default function PillToggle(props){
  const {
    pills = [],
    className,
    ...rest
  } = props

  return (
    <div {...rest} className={[styles.container, className]}>
      {pills.map((pill, index) => (
        <a
          key={index}
          href={pill.url}
          className={[
            styles.toggle,
            pill.className,
            pill.active && styles.active,
          ]}
        >
          {pill.icon}
          <span>{pill.text}</span>
        </a>
      ))}
    </div>
  )
}
